import sensors from 'sa-sdk-javascript'

type dataType =
  | 'string'
  | 'number'
  | 'bigint'
  | 'boolean'
  | 'symbol'
  | 'undefined'
  | 'object'
  | 'function'

const getStorage = (key: string) => {
  const storage = window.localStorage
  const storageData = storage.getItem(key)
  if (!storageData) return storageData
  try {
    const resData = JSON.parse(storageData)
    const dataType: dataType = resData.type
    const { data } = resData

    // 布尔值 返回data
    if (dataType === 'boolean') return data === true
    // 对象返回
    if (dataType === 'string' && data === 'null') {
      return null
    }
    // z字符串返回
    if (dataType === 'string' && data === 'undefined') return undefined
    // number
    if (dataType === 'number') return Number(data)
    return data
  } catch (error) {
    return storageData
  }
}

const getUrlParam = (name: string, searchStr?: string): string | null => {
  const { search, hash } = window.location

  const hashSearch = hash.split('?')[1]

  searchStr = searchStr || search.substr(1) || hash.split('?')[1] || ''
  if (hashSearch) searchStr += `${searchStr ? '&' : ''}${hashSearch}`
  if (searchStr.indexOf('?') !== -1) searchStr = searchStr.split('?')[1]
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = searchStr.match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

const isDevMode = process.env.NODE_ENV === 'development'

export default function initSensor() {
  if (window.sensors) {
    console.log('sensor has been run!!')
    return
  }
  const env = process.env.UMI_ENV || ''
  const showLog =
    env === 'dev' ||
    process.env.NODE_ENV === 'development' ||
    localStorage.getItem('showLog') === '1'

  console.log('showLog', showLog)
  // TODO 本地先强制开启 需补充根据接口来开启
  window.sensors = sensors
  const reportUrls: Record<string, string> = {
    'ali-uat': 'https://import-sensors.dragonpass.com.cn/sa?project=default',
    dev: 'https://import-sensors.dragonpass.com.cn/sa?project=default',
    test: 'https://import-sensors.dragonpass.com.cn/sa?project=default',
    uat: 'https://import-sensors.dragonpass.com.cn/sa?project=default',
    prod: 'https://import-sensors.dragonpass.com.cn/sa?project=production',
  }

  sensors.init({
    // server_url: 'server_url',
    server_url:
      reportUrls?.[env] ??
      'https://import-sensors.dragonpass.com.cn/sa?project=default',
    // server_url:  'https://longhuitengyun-poc.datasink.sensorsdata.cn/sa?project=default&token=7158b120f2afd5a2',
    // is_track_single_page: true, // 单页面配置，默认关闭。开启后自动监听 URL 有变化就会触发 $pageview 事件
    use_client_time: true,
    send_type: 'beacon',
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'not_collect',
      // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect',
      collect_tags: 'not_collect',
      // collect_tags: {
      //   div: true,
      //   li: true,
      // },
    },
    show_log: false,
  })
  console.log('initSensor')
}
